import { AppCoreModel, IAppBaseModel, IDiscount, CalcType, ModelPrefix } from "@posx/core";
import { nanoid } from 'nanoid';

export type TDiscountItem = Omit<IDiscount, 'percent_amount'> & Omit<IAppBaseModel, 'id_in_server' | '_timestamp'> ;

export class DiscountItem extends AppCoreModel implements TDiscountItem {
    uid: string = ModelPrefix.InvoiceDiscount + nanoid();
    name: string = '';
    name_translations: Record<string, string> = {};
    calc_type: CalcType = CalcType.Percent;
    amount: number = 0;
    percent: number = 0;
    percent_amount: number = 0;

    toDiscount(): IDiscount {
        return {
            name: this.name,
            name_translation: this.name_translations,
            uid: this.uid,
            calc_type: this.calc_type,
            amount: this.amount,
            percent: this.percent
        };
    }
}
